// extracted by mini-css-extract-plugin
module.exports = {"content":"termPersonal_content_1vZRS","title":"termPersonal_title_1iJWT","fs":"termPersonal_fs_1P8Bv"};